<app-multiselect-autocomplete
  [clearTrigger]="clearTrigger"
  [placeholder]="placeholder"
  [filterDisabled]="filterDisabled"
  [data]="entityList()"
  [panelWidth]="panelWidth"
  [valueToSelect]="valueToSelect"
  [valueToSearch]="valueToSearch"
  [maxElementsToSelect]="maxElementsToSelect"
  [returnFullValue]="returnFullValue"
  [disableCondition]="disableCondition"
  (elementsListed)="emitEntitiesListed($event)"
  (result)="emitDestinationEntities($event)">
</app-multiselect-autocomplete>
